'use client';

import React, { PropsWithChildren, createContext, use } from 'react';

import { hstack } from '@flipster/styled-system/patterns';

import TradingView from '../trading-view';

export const TvHeaderContext = createContext<{ tv: TradingView | null }>({ tv: null });

export const useTvHeaderContext = () => {
  const { tv } = use(TvHeaderContext);
  if (!tv) throw Error('TV context not found');
  return tv;
};

const BaseCustomHeader = ({ tv, children }: PropsWithChildren<{ tv: TradingView }>) => {
  return (
    <TvHeaderContext value={{ tv }}>
      <div
        className={hstack({
          justify: 'space-between',
          h: 36,
          maxW: '100%',
          px: 2,
          overflowX: 'auto',
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderBottomColor: 'border.default.level-1',
        })}
      >
        {children}
      </div>
    </TvHeaderContext>
  );
};

const HeaderSection = ({ children }: PropsWithChildren) => {
  return <div className={hstack({ h: '100%' })}>{children}</div>;
};

export const CustomHeader = Object.assign(BaseCustomHeader, { HeaderSection });
